// @merchant Generated deployment address constants; use proxy addresses for user calls.
export const NETWORK_NAME = "merchant-bsc";
export const CHAIN_ID = 56;
export const FORK_CHAIN_ID = null;
export const FORK_INSTANCE_ID = null;
export const DEPLOYMENT_RUN = "2026-11-02T14-29-39-743Z-upgrade";
export const PRODUCTION_DEPLOYED = true;
export const AMOUNT_DECIMALS = 18;
export const MA_V2 = "0xa2F9782Bb1106146eD6BA502333Aa7Fa8200f7a7";
export const MERCHANT_MANAGER = "0x8d6c7Cb2613A3804C9019Bfe1e23fd5b89049583";
export const MERCHANT_SWAP = "0xF5520763F5c08716fd5baf960ec190a8fB59f789";
export const REWARD_CONTROLLER = "0x2F08d17fc5fBbab6021deAF97c1Cee47bd3E9799";
export const MANAGER_WALLET_FACTORY = "0x32065a44b27EFc034Ee237b083623463Bd30e37f";
export const SWAP_WALLET_FACTORY = "0xf5306152b99e05967c2407E870Edd00b938a54CF";
export const USD = "0xB72DdbED942E7D369ddcfe9D433b35ef7775076c";
export const USD2 = "0x4AB70B6Bc5E8B93bcC1345f7a52193e16C516e04";
export const USDT = "0x55d398326f99059fF775485246999027B3197955";
export const CVC = "0xB45e6Dd851df10961D1aAD912BaF220168FCAA25";
export const CVCD = "0xBA12E794a3d9dbe504b424a80C08af0aCeB50b81";
export const DAO = "0x5e524bef585A5078a98a847c0CCB7aab76A9B3Dd";
export const EQUITY_RECEIVER = "0x0343c58e3a58904AeaF75cD1F0ae1CC2d616C1B5";
export const SAFETY_VAULT = "0xDbf42f88D2811B82CB6A11B474B41F37C7329E80";

// @stair-migration Keep independent CvcdSwap activation explicit.
export const CVCD_SWAP = "0x42cF5c82FdFc17022f9dE02A1B0d34323177d75A";
export const CVCD_EXIT_ENABLED = false;
